import {ArrayFilter, Reference} from '@/model/types';

export const ArrayFilterHelpers = {
  isNotIn<TField extends string, T extends string[]>(field: TField, value: T) {
    return {field, operator: 'not in', value} as const satisfies ArrayFilter;
  },

  isIn<TField extends string, T extends string[]>(field: TField, value: T) {
    return {field, operator: 'in', value} as const satisfies ArrayFilter;
  },

  isEqual<TField extends string, T extends string | Reference>(field: TField, value: T) {
    return {field, operator: '=', value} as const satisfies ArrayFilter;
  },

  isDifferent<TField extends string, T extends string | Reference>(field: TField, value: T) {
    return {field, operator: '!=', value} as const satisfies ArrayFilter;
  },
};
